const forms = {
  onRequest: "Bajo pedido", // translated
  person: "persona", // translated
  travelDate: "Fecha de viaje", // translated
  cancel: "Cancelar", // translated
  getPrice: "Obtener precio", // translated
  travelDates: "Fechas de viaje", // translated
};


export default forms;
